// eslint-disable-next-line import/extensions
import { getPitchName } from './pitch-names.js'

export default function getShortPitchName(
    type?: string,
    useShort: boolean = false
) {
    if (!type) {
        console.warn('No pitch type found')
        return ''
    }

    if (useShort) {
        return type.toUpperCase()
    }
    switch (type.toLowerCase()) {
        case 'ff':
            return '4-Seam'
        case 'cu':
            return 'Curve'
        case 'fs':
            return 'Split'
        case 'ch':
            return 'Change'
        case 'kn':
            return 'Knuckle'
        case 'kc':
            return 'Kn. Curve'
        case 'in':
            return 'Int. Ball'
        default:
            return getPitchName(type)
    }
}
